function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareKeys from '../../../../../../locales/keys';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { BILLING_EFFECTIVE_DATE_ORDER_OPTIONS, REASON_CODES, SCHEDULED_ORDER_OPTIONS } from '../../../../../../../src/customercare.constants';
import moment from 'moment';
import clone from 'ramda/src/clone';
var FutureDatedOrdersController = /*#__PURE__*/function () {
  function FutureDatedOrdersController($timeout) {
    _classCallCheck(this, FutureDatedOrdersController);
    Object.assign(this, {
      $timeout: $timeout,
      BILLING_EFFECTIVE_DATE_ORDER_OPTIONS: BILLING_EFFECTIVE_DATE_ORDER_OPTIONS,
      billingEffectiveDefaultDate: moment().startOf('day').toDate(),
      billingEffectiveMaximumDate: null,
      billingEffectiveMinimumDate: null,
      BUYERS_REMORSE: REASON_CODES.BUYERS_REMORSE,
      CustomerCareKeys: CustomerCareKeys,
      defaultExecutionOptions: {
        effective: "".concat(SCHEDULED_ORDER_OPTIONS.EFFECTIVE_IMMEDIATELY)
      },
      executionOptionsModel: {},
      filteredBillingEffectiveDateOptions: [],
      isBillingEffectiveDateInvalid: false,
      isFutureDatedOrderDateInvalid: false,
      MAXIMUM_COMMENT_LENGTH: 500,
      onBedDateChange: this.onBedDateChange.bind(this),
      onSpecifiedDateChange: this.onSpecifiedDateChange.bind(this),
      SCHEDULED_ORDER_OPTIONS: SCHEDULED_ORDER_OPTIONS
    });
  }
  return _createClass(FutureDatedOrdersController, [{
    key: "$onInit",
    value: function $onInit() {
      this.executionOptionsModel = this.executionOptionsSavedCopy && this.executionOptionsSavedCopy.effective ? clone(this.executionOptionsSavedCopy) : this.defaultExecutionOptions;
      if (!this.initializeDatesToNull) {
        if (this.orderAllowedForToday) {
          this.executionOptionsModel.specifiedDateFromPicker = this.executionOptionsSavedCopy && this.executionOptionsSavedCopy.specifiedDate || this.minDate;
        } else {
          this.executionOptionsModel.specifiedDate = this.executionOptionsSavedCopy && this.executionOptionsSavedCopy.specifiedDate || this.getExecutionDate();
        }
      }
      if (!this.showImmediateOption && this.showBillCycleOption && !this.executionOptionsSavedCopy.effective) {
        this.executionOptionsModel.effective = "".concat(SCHEDULED_ORDER_OPTIONS.ON_NEXT_BILL_CYCLE);
      }
      if (!this.showImmediateOption && !this.showBillCycleOption && this.showDatePickerOption) {
        this.executionOptionsModel.effective = "".concat(SCHEDULED_ORDER_OPTIONS.ON_SPECIFIED_DATE);
      }
      this.executionOptionsModel.applyBalanceToInvoice = true;
      this.onExecutionOptionChange()(this.executionOptionsModel);
      if (this.isBillingEffectiveDateShown && this.billingEffectiveDateOptions && this.billingEffectiveDateOptions.length) {
        this.filterAndFormatBillingEffectiveDateOptions(true);
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (this.isBillingEffectiveDateShown && this.executionOptionsModel.effective && changesObj.billingEffectiveDateOptions && changesObj.billingEffectiveDateOptions.currentValue.length) {
        this.filterAndFormatBillingEffectiveDateOptions(true);
      }
      if (!this.showBillCycleOption && this.executionOptionsModel && this.executionOptionsModel.effective === "".concat(SCHEDULED_ORDER_OPTIONS.ON_NEXT_BILL_CYCLE)) {
        this.executionOptionsModel.specifiedDate = null;
      }
      if (this.executionOptionsModel && this.executionOptionsModel.disconnectReason) {
        this.onExecutionOptionChange()(this.executionOptionsModel);
      }
      if (changesObj.minDate) {
        this.minDateObj = moment(changesObj.minDate.currentValue);
      }
      if (changesObj.maxDate) {
        this.maxDateObj = moment(changesObj.maxDate.currentValue);
      }
    }
  }, {
    key: "getBillingEffectiveMaxDate",
    value: function getBillingEffectiveMaxDate() {
      switch (convertStringToNumber(this.executionOptionsModel.effective)) {
        case SCHEDULED_ORDER_OPTIONS.EFFECTIVE_IMMEDIATELY:
          return moment();
        case SCHEDULED_ORDER_OPTIONS.ON_NEXT_BILL_CYCLE:
          return moment(this.billCycleDate);
        case SCHEDULED_ORDER_OPTIONS.ON_SPECIFIED_DATE:
          var maxDate = this.executionOptionsModel.specifiedDateFromPicker || this.executionOptionsModel.specifiedDate || this.defaultExecutionOptions.specifiedDate;
          return maxDate ? moment(maxDate) : null;
        default:
          return null;
      }
    }
  }, {
    key: "setBillingEffectiveDateAndRange",
    value: function setBillingEffectiveDateAndRange() {
      var momentMinimumNonFutureDatedOrderDate = moment(this.billingEffectiveDateSettings.minimumDate).add(1, 'hours');
      if (this.billingEffectiveDateSettings.pastDateMaxLength && convertStringToNumber(this.executionOptionsModel.effective) !== SCHEDULED_ORDER_OPTIONS.EFFECTIVE_IMMEDIATELY) {
        // Subtract the configured amount, and take the largest of the 2 possible min dates.
        var momentMinimumFutureDatedOrderDate = moment(this.getExecutionDate()).subtract(this.billingEffectiveDateSettings.pastDateMaxLength, 'days');
        this.billingEffectiveMinimumDate = moment(momentMinimumFutureDatedOrderDate).isAfter(momentMinimumNonFutureDatedOrderDate) ? momentMinimumFutureDatedOrderDate : momentMinimumNonFutureDatedOrderDate;
      } else {
        this.billingEffectiveMinimumDate = momentMinimumNonFutureDatedOrderDate;
      }
      this.billingEffectiveMaximumDate = this.getBillingEffectiveMaxDate();
    }
  }, {
    key: "filterAndFormatBillingEffectiveDateOptions",
    value: function filterAndFormatBillingEffectiveDateOptions() {
      var _this = this;
      var isQuoteSkipped = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var filteredBillingEffectiveDateOptions = {};
      var savedBillingEffectiveIntention = convertStringToNumber(this.executionOptionsModel.billingEffectiveIntention);
      this.billingEffectiveDateOptions.forEach(function (option) {
        if (option.Valid) {
          var isDisabled = option.OrderExecutionDateIntention !== convertStringToNumber(_this.executionOptionsModel.effective);
          var isShown = !isDisabled || !filteredBillingEffectiveDateOptions[option.BillingEffectiveDateIntention];
          var isSelected = !isDisabled && savedBillingEffectiveIntention === option.BillingEffectiveDateIntention;
          if (isShown) {
            filteredBillingEffectiveDateOptions[option.BillingEffectiveDateIntention] = Object.assign({}, option, {
              isDisabled: isDisabled,
              isSelected: isSelected
            });
          }
          if (option.Default) {
            _this.executionOptionsModel.billingEffectiveIntention = "".concat(option.BillingEffectiveDateIntention);
          }
        }
      });
      if (filteredBillingEffectiveDateOptions[savedBillingEffectiveIntention] && !filteredBillingEffectiveDateOptions[savedBillingEffectiveIntention].isDisabled) {
        this.executionOptionsModel.billingEffectiveIntention = "".concat(savedBillingEffectiveIntention);
      }
      this.filteredBillingEffectiveDateOptions = Object.values(filteredBillingEffectiveDateOptions);
      this.setBillingEffectiveDateAndRange();
      this.updateExecutionOptions(false, isQuoteSkipped);
    }
  }, {
    key: "getExecutionDate",
    value: function getExecutionDate() {
      switch (this.executionOptionsModel.effective) {
        case "".concat(SCHEDULED_ORDER_OPTIONS.EFFECTIVE_IMMEDIATELY):
          return null;
        case "".concat(SCHEDULED_ORDER_OPTIONS.ON_NEXT_BILL_CYCLE):
          return moment(this.billCycleDate).toISOString();
        case "".concat(SCHEDULED_ORDER_OPTIONS.ON_SPECIFIED_DATE):
          return this.executionOptionsModel.specifiedDateFromPicker;
        default:
          return null;
      }
    }
  }, {
    key: "updateCreditCheckFinancing",
    value: function updateCreditCheckFinancing() {
      this.updateExecutionOptions(true);
    }
  }, {
    key: "updateExecutionOptions",
    value: function updateExecutionOptions() {
      var isCreditCheckFinancingChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isQuoteSkipped = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isReasonChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.executionOptionsModel.specifiedDate = this.getExecutionDate();
      this.fdoExecutionOptionsForm && this.fdoExecutionOptionsForm.SpecifiedDate && this.fdoExecutionOptionsForm.SpecifiedDate.$setValidity('invalidOrderScheduledForDate', !this.isFutureDatedOrderDateInvalid);
      if (this.isBillingEffectiveDateShown) {
        this.isBillingEffectiveDateInvalid = this.executionOptionsModel.billingEffectiveIntention && convertStringToNumber(this.executionOptionsModel.billingEffectiveIntention) === BILLING_EFFECTIVE_DATE_ORDER_OPTIONS.ON_SPECIFIED_DATE && !this.executionOptionsModel.billingEffectiveDate;
        this.fdoExecutionOptionsForm && this.fdoExecutionOptionsForm.BillingEffectiveDate && this.fdoExecutionOptionsForm.BillingEffectiveDate.$setValidity('invalidBillingEffectiveDate', !this.isBillingEffectiveDateInvalid);
      }
      if (this.executionOptionsModel.billingEffectiveIntention !== BILLING_EFFECTIVE_DATE_ORDER_OPTIONS.ON_SPECIFIED_DATE.toString()) {
        this.executionOptionsModel.billingEffectiveDate = null;
      }
      if (this.executionOptionsModel.effective !== BILLING_EFFECTIVE_DATE_ORDER_OPTIONS.ON_SPECIFIED_DATE.toString()) {
        this.executionOptionsModel.specifiedDate = null;
        this.executionOptionsModel.specifiedDateFromPicker = null;
      }
      if (this.executionOptionsModel.effective === SCHEDULED_ORDER_OPTIONS.ON_SPECIFIED_DATE.toString() && (!this.executionOptionsModel.specifiedDate || !this.executionOptionsModel.specifiedDateFromPicker)) {
        var defaultDate = this.executionOptionsSavedCopy && this.executionOptionsSavedCopy.specifiedDate || this.minDate;
        this.executionOptionsModel.specifiedDate = defaultDate;
        this.executionOptionsModel.specifiedDateFromPicker = defaultDate;
        if (this.isBillingEffectiveDateShown) {
          this.billingEffectiveMaximumDate = this.getBillingEffectiveMaxDate();
        }
      }
      this.onExecutionOptionChange()(this.executionOptionsModel, isCreditCheckFinancingChange, isReasonChange);
      this.doErrorsExistOnFdoForm()(this.fdoExecutionOptionsForm && this.fdoExecutionOptionsForm.$invalid);
      if (this.isBillingEffectiveDateShown && this.recalculateQuote && !isQuoteSkipped && !this.isBillingEffectiveDateInvalid && !this.isFutureDatedOrderDateInvalid) {
        this.recalculateQuote()();
      }
      this.onExecutionOptionChange()(this.executionOptionsModel);
      this.isFutureDatedOrderDateInvalid = this.executionOptionsModel.effective && convertStringToNumber(this.executionOptionsModel.effective) === SCHEDULED_ORDER_OPTIONS.ON_SPECIFIED_DATE && !this.executionOptionsModel.specifiedDate;
    }
  }, {
    key: "onSpecifiedDateChange",
    value: function onSpecifiedDateChange(date) {
      if (this.isBillingEffectiveDateShown) {
        this.billingEffectiveMaximumDate = this.getBillingEffectiveMaxDate();
      }
      this.executionOptionsModel.effective = "".concat(this.SCHEDULED_ORDER_OPTIONS.ON_SPECIFIED_DATE);
      this.executionOptionsModel.specifiedDateFromPicker = date || null;
      this.isBillingEffectiveDateShown ? this.filterAndFormatBillingEffectiveDateOptions() : this.updateExecutionOptions();
    }
  }, {
    key: "onBedDateChange",
    value: function onBedDateChange(date) {
      this.executionOptionsModel.billingEffectiveIntention = "".concat(BILLING_EFFECTIVE_DATE_ORDER_OPTIONS.ON_SPECIFIED_DATE);
      this.executionOptionsModel.billingEffectiveDate = date || null;
      this.updateExecutionOptions(false, !this.executionOptionsModel.billingEffectiveDate);
    }
  }]);
}();
export default {
  template: require('./future.dated.orders.html'),
  bindings: {
    billCycleDate: '<',
    billCycleToolTipContent: '<',
    billingEffectiveDateOptions: '<?',
    billingEffectiveDateSettings: '<?',
    disconnectAndRemoveOfferCustomerReasons: '<?',
    doErrorsExistOnFdoForm: '&',
    executionOptionsSavedCopy: '<',
    initializeDatesToNull: '<?',
    isBillingEffectiveDateShown: '<?',
    isFullDisconnect: '<?',
    isNewConnect: '<',
    isNotExpanded: '<?',
    maxDate: '<',
    minDate: '<',
    onExecutionOptionChange: '&',
    onFdoFormValidityChange: '&?',
    orderAllowedForToday: '<',
    recalculateQuote: '&?',
    showApplyBalanceToInvoice: '<?',
    showBillCycleOption: '<?',
    showBillCycleToolTip: '<?',
    showDatePickerOption: '<?',
    showImmediateOption: '<?'
  },
  controller: FutureDatedOrdersController
};